import React from "react";
import { Theme, useTheme } from '@mui/material/styles'
import { makeStyles } from "@mui/styles";
import {
  Button,
  Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText,
  TextField,
} from "@mui/material";

interface Inputs {
  open: any;
  onClose: any;
  onSelection: any;
}

export default function DateAct(props: Inputs) {
  const useStyles = makeStyles((theme: Theme) => ({
    button: {
      margin: theme.spacing(2),
    }
  }));
  const today = new Date().toISOString().split("T")[0];
  const [date, setDate] = React.useState(today);

  const handleDateChange = (event: any) => {
    event.persist();
    setDate(event.target.value);
  }

  const classes = useStyles();

  if (props.open === false) {
    return null;
  }

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      aria-labelledby="dri-title"
      open={props.open}
      onClose={props.onClose}
    >
        <DialogTitle id="dri-title">Schedule Visit</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Select Next Visit Date
          </DialogContentText>
          <TextField fullWidth={false} type="date" value={date} onChange={(ce)=>handleDateChange(ce)}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.onClose()} color="primary">
            Abort
          </Button>
          <Button onClick={() => props.onSelection(date)} color="primary" autoFocus>
            Yes, proceed
          </Button>
        </DialogActions>
    </Dialog>
  );
}
